import { render, staticRenderFns } from "./AssistantActionEdit.vue?vue&type=template&id=64cc46c8&scoped=true&"
import script from "./AssistantActionEdit.vue?vue&type=script&lang=js&"
export * from "./AssistantActionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cc46c8",
  null
  
)

export default component.exports